const ARCHIVING = 'archiving';
const DISPLAY_PREFERENCES = 'displayPreferences';
const EMPLOYEE_REPORTS = 'employeeReports';
const SHIFT_SWAP_SETUP = 'shiftSwapSetup';
const MANUAL_OVERRIDE = 'manualOverride';
const GLOBAL = 'global';

export const AdminGlobalSetupSections = Object.freeze({
    [ARCHIVING]: 0,
    [DISPLAY_PREFERENCES]: 1,
    [EMPLOYEE_REPORTS]: 2,
    [SHIFT_SWAP_SETUP]: 3,
    [MANUAL_OVERRIDE]: 4,
    [GLOBAL]: 5,
});

const IndexedAdminGlobalSetupSections = Object.freeze({
    0: ARCHIVING,
    1: DISPLAY_PREFERENCES,
    2: EMPLOYEE_REPORTS,
    3: SHIFT_SWAP_SETUP,
    4: MANUAL_OVERRIDE,
    5: GLOBAL,
});

export const AdminGlobalSetupSectionNames = Object.freeze({
    [ARCHIVING]: IndexedAdminGlobalSetupSections[AdminGlobalSetupSections.archiving],
    [DISPLAY_PREFERENCES]: IndexedAdminGlobalSetupSections[AdminGlobalSetupSections.displayPreferences],
    [EMPLOYEE_REPORTS]: IndexedAdminGlobalSetupSections[AdminGlobalSetupSections.employeeReports],
    [SHIFT_SWAP_SETUP]: IndexedAdminGlobalSetupSections[AdminGlobalSetupSections.shiftSwapSetup],
    [MANUAL_OVERRIDE]: IndexedAdminGlobalSetupSections[AdminGlobalSetupSections.manualOverride],
    [GLOBAL]: IndexedAdminGlobalSetupSections[AdminGlobalSetupSections.global],
});

export const PostedRequestDisplay = Object.freeze({
    requestName: 0,
    shiftTime: 1,
});

export const ArchiveImpactOnRequests = Object.freeze({
    archiveAfterRequestCompletion: 0,
    archiveAndAutoRetractPendingRequests: 1,
});
